import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '@/components/Avatar/Avatar';
import { validateYouTubeUrl } from '@/util/utils';
import styles from './Message.module.scss';
export const Url = ({ url, title, avatar, onClick }) => {
    const validYoutubeUrl = validateYouTubeUrl(url);
    return (_jsxs(_Fragment, { children: [_jsx(Avatar, { avatar: avatar }), !validYoutubeUrl ? (_jsx("a", { className: styles.link, href: url, target: "_blank", onClick: () => onClick({
                    type: 'url',
                    label: title || url,
                    value: url,
                }), rel: "noreferrer", children: title || url })) : (_jsx("iframe", { id: title, title: title, width: "100%", height: "265", frameBorder: "0", allowFullScreen: true, src: validYoutubeUrl }))] }));
};
